<template>
  <div class="uk-card teamcard">
    <div class='timestorage' style='display:none'></div>
    <div class="card-header uk-card-header">
      <S3Image width="50" :src="'teams/' + data.logo"/>
      <span class="uk-margin-large-left">{{data.name}}</span>
    </div>
    <div class="uk-card-body card-body score-board">
      <div class='card-section'>
        <div uk-grid class='score-row'>
          <div class='uk-width-1-1@m numbox bigscore'>
            <p class='team-score numbox-head'>Score</p>
            <h3 class='numbox-num '>{{data.score}}</h3>
          </div>
          <!--<div class='uk-width-1-2@m numbox'>-->
            <!--<div uk-grid>-->
              <!--<div-->
                <!--class="uk-width-1-2 uk-margin-small-top"-->
                <!--v-for="metric in data.score_component"-->
                <!--:key="metric.name"-->
                <!--:uk-tooltip="'title:' + metric.description + '; pos: top'"-->
              <!--&gt;-->
                <!--<p class='match-rank numbox-head'>{{metric.name}}</p>-->
                <!--<h3 class='numbox-num'>{{metric.value}}</h3>-->
              <!--</div>-->
              <!--&lt;!&ndash;<div class="uk-width-1-2 uk-margin-small-top">&ndash;&gt;-->
                <!--&lt;!&ndash;<p class='overall-rank numbox-head'>Quarter</p>&ndash;&gt;-->
                <!--&lt;!&ndash;<h3 class='numbox-num'>03</h3>&ndash;&gt;-->
              <!--&lt;!&ndash;</div>&ndash;&gt;-->
            <!--</div>-->
          <!--</div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	import S3Image from "@/components/theme/S3Image";
	export default {
		name: "Scoreboard",
		components: {S3Image},
		props: ["data"]
	}
</script>

<style lang="less" scoped>

  @import "../../../assets/less/palette.less";
  @import "../../../assets/less/theme.less";


@darkblue: @primary-3;
@darkbg: @slate;
@darkaccent: darken(@slate, 10%);
@lightfont: #eee;
@highlightcolor: #81e8a7;
@card-body-height: 200px;
@card-header-height: 60px;
@card-footer-height: 50px;
@major-font: 'Anton';
@scoreboardshadow: 4px 4px 5px rgba(0,0,0,.9);
@navbar-color:  pink;


.teamcard {
  width: 100%;
  min-width: 340px;
  max-width: 600px;
  /*<!--font-family: @major-font, sans-serif;-->*/
  border: none;
  background: rgba(0,0,0,0);
  position: relative;
  border-radius: 0;

  .card-body, .card-header, .card-footer, .card-body {
     border: none;
   }

  .team-logo {
    max-height: 50px;
  }

  .winner {
    position: absolute;
    background-size: 100% 100% ;
    height: 150px;
    width: 150px;
    top: -80px;
    left: -70px;

  }

  .card-header {

    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: nowrap;

    padding: 8px;
    text-align: center;
    margin-bottom: .8em;
    height: 60px;
    line-height: 30px;
    font-size: 30px;

    ////CHANGE THESE COLORS
    background: @darkbg;
    color: @lightfont;
    position: relative;
    z-index: 2;
    /*<!--box-shadow: @scoreboardshadow;-->*/


    img {
      margin-right: 1em;
    }
  }

  .card-header:after {
    z-index: 1;
    position: absolute;
    bottom: -1.3em;
    left: 20%;
    width: 60%;
    height: 1.3em;
    border: 4px solid @darkbg;
    border-top: none;
    border-bottom: none;
    content: " ";
  }

  .card-footer {
    background: none;
    height: 30px;

  .btn-group {
    margin: 0 auto;
    box-shadow: @scoreboardshadow;
  }

    .btn {
      background: @darkbg;
      color: @lightfont;
      border: none;
    }

    .btn:hover {
      color: @darkbg;
      background: @lightfont;
      cursor: pointer;
    }
  }

  .card-body {
    /*<!--height: @card-body-height;-->*/
    overflow-y: hidden;
    position: relative;
    margin: 8px 0 5px 0;
    padding: .4em;
    background-color: rgba(@darkbg,1);
    opacity: 1;
    border-radius: 8px;
  }

  .score-row {

    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    justify-content: center;
    /*margin: 1em .6em;*/

    .numbox {
        padding: .2em;
        margin: 0;
        text-align: center;
        color: white!important;


        .numbox-head {
          font-family: Roboto, Sans-Serif;
          font-size: 13px;
          margin-bottom: 3px;
          margin-top: 10px;
          padding: 0;
          line-height: 12px;
          text-transform: uppercase;

        }





      &.bigscore {
        .numbox-num {
          font-size: 4em;
          margin: 7px 4px 4px 4px;
          color: white;
        }

        .numbox-head {
           font-size: 1.5em;
          margin-top: 1.6em;
        }

      }

        .numbox-num {

          position: relative;
          font-family: Roboto, Sans-Serif;
          font-size: 2.1em;
          line-height: .75em;
          padding: 0;
          margin: 2px;

          padding:  .2em .1em;
            display: inline-block;
            background: @darkaccent;
            -webkit-border-radius: 3px;
            border-radius: 3px;
            text-transform: uppercase;
            color: white;
            -webkit-box-shadow:
                inset 2px 0px 4px rgba(0,0,0,0.9),
                inset -2px 0px 4px rgba(0,0,0,0.9);
            box-shadow: 2px 0px 4px rgba(0,0,0,0.9);

            text-shadow:
             -1px -1px 0 #000,
              1px -1px 0 #000,
              -1px 1px 0 #000,
               1px 1px 0 #000;



        }

    }


  }

  span.letter.spacer {
    display: none!important;
  }

}

teamcard.winner {
  position: relative;

  &:before {
    position: absolute;
     background-image: url("/static/arena/assets/graphics/fireworks1.jpg");
    background-size: 100% 100% ;
    height: 80px;
    width: 80px;
    top: -20px;
    left: -10px;
    content: " ";

  }

}

</style>
